export default __webpack_public_path__ + "static/editing-notes_desktop-9a193eb545e2005b76cfe41b015cfc1b.jpg";